import type { ReactNode } from 'react';
import { Component } from 'react';
import type { IBreadcrumbItem } from '../elements/common';
import { Breadcrumb } from '../elements/common';

/**
 * @deprecated use PageTemplate instead
 */
export class FixedWidthTemplate extends Component<
    { breadcrumb?: IBreadcrumbItem[]; children: ReactNode; id?: string },
    {}
> {
    public render() {
        const result = [];
        if (this.props.breadcrumb) {
            result.push(
                <div
                    className="row"
                    key="0"
                >
                    <div className="col-sm-24">
                        <Breadcrumb items={this.props.breadcrumb} />
                    </div>
                </div>
            );
        }
        result.push(
            <div
                className="row justify-content-md-center"
                key="1"
            >
                <div className="col-sm-24 col-md-22 col-lg-22 col-xl-18 col-xl-14">{this.props.children}</div>
            </div>
        );

        return (
            <div
                className="container"
                id={this.props.id}
            >
                {result}
            </div>
        );
    }
}
